import React from 'react'

function List(props) {
  const files = props.files
  return (
    <ul>
      {files.map((file, index) => <li key={index}><a href={file.url} download={file.name}>{file.name}</a></li>)}
    </ul>
  )
}

export default List